import GooglePublisherTag from 'components/shared/GooglePublisherTag/GooglePublisherTag';
import SharedBannerAd from 'components/shared/BannerAd/BannerAd';

export default class BannerAd {
  static setup() {
    var gpt = window.kmklabs.gpt;

    if(gpt.top_banner_ad_unit && gpt.top_banner_ad_size)
      BannerAd.setTopBanner(gpt);

    if(gpt.pause_ad_unit && gpt.pause_ad_size)
      GooglePublisherTag.setAdPause(gpt.pause_ad_unit, gpt.pause_ad_size);
    
    if(gpt.overlay_ad_unit && gpt.overlay_ad_size)
      GooglePublisherTag.setAdOverlay(gpt.overlay_ad_unit, gpt.overlay_ad_size);

    if(gpt.middle_banner_ad_unit && gpt.middle_banner_ad_size) {
      SharedBannerAd.setBannerAd(
        "middle_banner_container",
        "middle_banner",
        gpt.middle_banner_ad_unit,
        gpt.middle_banner_ad_size,
        GooglePublisherTag.setAdMiddleBanner);
    }
  }

  static setTopBanner(gpt) {
    SharedBannerAd.setBannerAd(
      "top_banner_container",
      "top_banner",
      gpt.top_banner_ad_unit,
      gpt.top_banner_ad_size,
      GooglePublisherTag.setAdTopBanner,
      () => {
        GooglePublisherTag.refreshAdSlot(gpt.top_banner, 'top_banner');
      }
    );
  };
} 